exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-slick-carousel-dot{margin:10px;height:8px;width:8px;background-color:var(--c-bg-dark);border-radius:100%;cursor:pointer}.slick-active>.vue-slick-carousel-dot{background-color:var(--c-primary)}", ""]);

// exports
